<p-accordion class="flex-grow-1" styleClass="faq py-10">
    <p-accordionTab *ngFor="let item of faqlist" header="{{item.faq.question}}">
       <p class="htmlContainer" [innerHtml]="item.faq.answer">

       </p>
    </p-accordionTab>
</p-accordion>
